// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.HighchartVizEngine.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import VizEngine from '../Izenda.VizEngine';
import Highcharts from 'highcharts';

import enhanceHighcharts from 'highcharts-more';
import funnel from 'funnel';
import heatmap from 'heatmap';
import treemap from 'treemap';
import solidGauge from 'solidGauge';
import izSolidGauge from './Izenda.SolidGauge';
import izLinearGauge from './Izenda.LinearGauge';
import izSimpleGauge from './Izenda.SimpleGauge';
import izRegressionLine from './Izenda.HighchartRegression';

import lineChart from './Izenda.LineChart';
import areaChart from './Izenda.AreaChart';
import autosize from './Izenda.AutoResizedChart';
import seriesLabel from './Izenda.SeriesLabel';
import { size } from 'lodash/fp';

import { Messages as UiMessages } from 'logic/data/Izenda.UIConstants';
import { exportClass } from 'share/Izenda.ServiceProvider';

// Apply highchart extensions
[
  enhanceHighcharts,
  funnel,
  heatmap,
  treemap,
  solidGauge,
  izSolidGauge,
  izLinearGauge,
  izSimpleGauge,
  lineChart,
  areaChart,
  autosize,
  seriesLabel,
  izRegressionLine
].forEach(fn => fn(Highcharts));

// Apply global settings to Highchart library
Highcharts.setOptions({ global: { useUTC: false } });

/**
 * Highchart visualization engine
 */
@exportClass('HighchartVizEngine')
export default class HighchartVizEngine extends VizEngine {
  static VisualizationLibrary = Highcharts;

  /**
   * Draw chart into chart container and return chart instance with releasing function
   * @param {DOMElement} chartContainer DOM element of chart
   * @param {string} chartType Izenda chart type
   * @param {Object} options Chart options
   * @param {Function} onCompleted A callback function to be invoked after finished rendering
   */
  draw(chartContainer, chartType, options, onCompleted) {
    __DEV__ && this.logHighchartOptions(options);

    const afterRender = this.afterRender;

    if (!size(options.series)) {
      return $izenda(chartContainer)
        .empty()
        .text(UiMessages.NoDataToShow);
    }

    const chartInstance = new Highcharts.Chart(chartContainer, options, function(...params) {
      afterRender(this);

      onCompleted(params);
    });

    return {
      chartInstance,
      destroy() {
        chartInstance && chartInstance.hasRendered && chartInstance.destroy();
      }
    };
  }

  /**
   *
   * @param {Object} highchartInstance Highchart Chart instance
   */
  afterRender(highchartInstance) {}
}



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.HighchartVizEngine.js